/* MACONDO size guide – custom, no app. Data comes from metaobject `macondo_size_guide` (json). */
(function () {
  if (customElements.get('macondo-size-guide')) return;

  const SCALE = { usa: 'US', us: 'US', uk: 'UK', eu: 'EU', it: 'IT', fr: 'FR', jp: 'JP' };
  const norm = (s) => String(s == null ? '' : s).trim().toLowerCase().replace(',', '.').replace(/\s+/g, ' ');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const range = (v) => {
    const n = String(v).replace(',', '.').match(/\d+(?:\.\d+)?/g);
    if (!n) return null;
    const a = parseFloat(n[0]), b = parseFloat(n[n.length - 1]);
    return [Math.min(a, b), Math.max(a, b)];
  };
  const toIn = (cm) => Math.round((cm / 2.54) * 10) / 10;

  class MacondoSizeGuide extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const raw = this.querySelector('script[type="application/json"]');
      if (!raw) return;
      try { this.cfg = JSON.parse(raw.textContent); } catch (e) { return; }
      const d = this.cfg.chart || {};
      this.cols = d.cols || [];
      this.rows = d.rows || [];
      this.m = d.m || [];               // measurement column indexes (cm)
      this.key = d.key || 0;            // column plain numeric labels refer to
      this.unit = 'cm';
      this.dialog = this.querySelector('dialog');
      this.querySelector('.msg-trigger').addEventListener('click', () => this.open());
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog || e.target.closest('[data-msg-close]')) this.close();
      });
      this.mapSizes();
      this.build();
    }

    colIndex(name) {
      const n = String(name).toUpperCase();
      return this.cols.findIndex((c) => String(c).toUpperCase().split(' ')[0] === n);
    }

    /* which chart rows a variant label (e.g. "7 usa", "XS/S", "42", "30/32") refers to */
    rowsFor(label) {
      const L0 = norm(label);
      const all = (ci, v) => this.rows.map((r, i) => (norm(r[ci]) === v ? i : -1)).filter((i) => i > -1);
      const inRange = (ci, v) => {
        const x = parseFloat(v);
        if (isNaN(x) || !/^\d+(\.\d+)?$/.test(v)) return [];
        return this.rows.map((r, i) => {
          const c = String(r[ci]);
          if (!/\d\s*[–-]\s*\d/.test(c)) return -1;
          const rg = range(c);
          return rg && x >= rg[0] && x <= rg[1] ? i : -1;
        }).filter((i) => i > -1);
      };
      const anyCol = (v) => {
        const order = [this.key].concat(this.cols.map((_, i) => i).filter((i) => i !== this.key));
        for (const ci of order) { if (this.m.includes(ci)) continue; const r = all(ci, v); if (r.length) return r; }
        for (const ci of order) { if (this.m.includes(ci)) continue; const r = inRange(ci, v); if (r.length) return r; }
        for (const ci of order) {
          if (this.m.includes(ci)) continue;
          const r = this.rows.map((row, i) => (String(row[ci]).includes('/') && norm(row[ci]).split('/').map((x) => x.trim()).includes(v) ? i : -1)).filter((i) => i > -1);
          if (r.length) return r;
        }
        return [];
      };
      const one = (L) => {
        const sc = L.match(/^(.+?)\s*(usa|us|uk|eu|it|fr|jp)$/);
        if (sc) {
          const ci = this.colIndex(SCALE[sc[2]]);
          if (ci > -1) { const r = all(ci, sc[1].trim()); if (r.length) return r; }
        }
        let r = anyCol(L);
        if (r.length) return r;
        if (/^0\d$/.test(L)) { r = anyCol(L.slice(1)); if (r.length) return r; }
        return [];
      };
      let r = one(L0);
      if (r.length) return r;
      if (L0.includes('/')) {
        const parts = L0.split('/').map((x) => x.trim()).filter(Boolean);
        if (parts.length === 2 && /^\d+$/.test(parts[0]) && /^\d+$/.test(parts[1]) && parseInt(parts[1], 10) >= 26) return one(parts[0]); // W/L denim
        let out = [];
        parts.forEach((p) => { out = out.concat(one(p)); });
        return [...new Set(out)].sort((x, y) => x - y);
      }
      return [];
    }

    mapSizes() {
      this.sizes = (this.cfg.sizes || []).map((s) => ({ ...s, rows: this.rowsFor(s.v) }));
      this.rowSizes = this.rows.map((_, i) => this.sizes.filter((s) => s.rows.includes(i)));
    }

    selectedLabel() {
      const scope = this.closest('[data-product-id], product-information, .product-information, section') || document;
      const checked = (scope.querySelector('variant-picker input[type="radio"]:checked') || document.querySelector('variant-picker input[type="radio"]:checked'));
      if (checked) return checked.value;
      const sel = document.querySelector('variant-picker select');
      return sel ? sel.value : null;
    }

    cell(v, ci) {
      if (!this.m.includes(ci) || this.unit === 'cm') return esc(v);
      const r = range(v);
      if (!r) return esc(v);
      return r[0] === r[1] ? toIn(r[0]) : toIn(r[0]) + '–' + toIn(r[1]);
    }

    head(ci) {
      const c = this.cols[ci];
      return esc(this.m.includes(ci) ? c + ' (' + this.unit + ')' : c);
    }

    tableHTML() {
      const sel = this.selectedLabel();
      const selRows = sel ? this.rowsFor(sel) : [];
      let h = '<div class="msg-table-wrap"><table class="msg-table"><thead><tr>';
      this.cols.forEach((_, ci) => { h += '<th scope="col">' + this.head(ci) + '</th>'; });
      h += '</tr></thead><tbody>';
      this.rows.forEach((row, i) => {
        const here = this.rowSizes[i].length > 0;
        const cls = [here ? 'is-here' : '', selRows.includes(i) ? 'is-selected' : ''].join(' ').trim();
        h += '<tr' + (cls ? ' class="' + cls + '"' : '') + '>';
        row.forEach((v, ci) => { h += (ci === 0 ? '<th scope="row">' : '<td>') + this.cell(v, ci) + (ci === 0 ? '</th>' : '</td>'); });
        h += '</tr>';
      });
      return h + '</tbody></table></div>';
    }

    build() {
      const d = this.cfg.chart;
      const body = this.querySelector('.msg-body');
      const hasM = this.m.length > 0;
      const shoes = this.cfg.cat === 'shoes';
      body.innerHTML =
        '<div class="msg-tabs" role="tablist">' +
        '<button type="button" role="tab" aria-selected="true" data-tab="chart">Size chart</button>' +
        '<button type="button" role="tab" aria-selected="false" data-tab="find">Find my size</button>' +
        '</div>' +
        '<div class="msg-panel" data-panel="chart">' +
        (hasM ? '<div class="msg-units"><button type="button" data-unit="cm" aria-pressed="true">cm</button><button type="button" data-unit="in" aria-pressed="false">in</button></div>' : '') +
        '<div class="msg-chart"></div>' +
        '<p class="msg-legend"><span class="msg-dot"></span> Sizes available for this item' + (this.selectedLabel() ? ' · <strong>selected size</strong> highlighted' : '') + '</p>' +
        (d.note ? '<p class="msg-note">' + esc(d.note) + '</p>' : '') +
        (hasM && !shoes ? '<p class="msg-note">Body measurements, not garment measurements.</p>' : '') +
        (shoes && this.cfg.chart.cm != null ? '<p class="msg-note">Foot length: stand on a sheet of paper, mark heel and longest toe, measure the distance.</p>' : '') +
        '</div>' +
        '<div class="msg-panel" data-panel="find" hidden>' + this.finderHTML() + '<div class="msg-result" aria-live="polite"></div></div>';
      this.renderTable();
      body.querySelectorAll('[data-tab]').forEach((b) => b.addEventListener('click', () => this.tab(b.dataset.tab)));
      body.querySelectorAll('[data-unit]').forEach((b) => b.addEventListener('click', () => {
        this.unit = b.dataset.unit;
        body.querySelectorAll('[data-unit]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        this.renderTable();
        this.syncFinderUnits();
      }));
      this.bindFinder();
    }

    renderTable() { this.querySelector('.msg-chart').innerHTML = this.tableHTML(); }

    tab(t) {
      this.querySelectorAll('[data-tab]').forEach((b) => b.setAttribute('aria-selected', String(b.dataset.tab === t)));
      this.querySelectorAll('[data-panel]').forEach((p) => { p.hidden = p.dataset.panel !== t; });
    }

    scales() {
      return this.cols.map((c, ci) => ({ c, ci })).filter((x) => !this.m.includes(x.ci));
    }

    finderHTML() {
      const shoes = this.cfg.cat === 'shoes';
      const sc = this.scales();
      let h = '<form class="msg-find" data-mode="usual"><fieldset><legend>' + (shoes ? 'Your usual shoe size' : 'Your usual size') + '</legend>' +
        '<div class="msg-row"><label>System<select name="scale">' + sc.map((x) => '<option value="' + x.ci + '">' + esc(x.c) + '</option>').join('') + '</select></label>' +
        '<label>Size<select name="val"></select></label></div></fieldset></form>';
      if (this.m.length) {
        h += '<form class="msg-find" data-mode="body"><fieldset><legend>' + (shoes ? 'Or your foot length' : 'Or your measurements') + '</legend><div class="msg-row">';
        this.m.forEach((ci) => {
          h += '<label>' + esc(this.cols[ci]) + ' <span class="msg-u">(' + this.unit + ')</span><input type="number" inputmode="decimal" step="0.5" min="0" name="m' + ci + '" placeholder="–"></label>';
        });
        h += '</div></fieldset></form>';
      }
      return h;
    }

    fillValues() {
      const f = this.querySelector('form[data-mode="usual"]');
      const ci = parseInt(f.scale.value, 10);
      const seen = [];
      this.rows.forEach((r) => { const v = r[ci]; if (v !== '' && v != null && !seen.includes(v)) seen.push(v); });
      f.val.innerHTML = '<option value="">–</option>' + seen.map((v) => '<option>' + esc(v) + '</option>').join('');
    }

    bindFinder() {
      const f = this.querySelector('form[data-mode="usual"]');
      this.fillValues();
      f.scale.addEventListener('change', () => { this.fillValues(); this.result([]); });
      f.val.addEventListener('change', () => {
        const ci = parseInt(f.scale.value, 10);
        const v = norm(f.val.value);
        this.result(v ? this.rows.map((r, i) => (norm(r[ci]) === v ? i : -1)).filter((i) => i > -1) : []);
      });
      const b = this.querySelector('form[data-mode="body"]');
      if (b) b.addEventListener('input', () => this.fromBody(b));
      this.querySelectorAll('form.msg-find').forEach((x) => x.addEventListener('submit', (e) => e.preventDefault()));
    }

    syncFinderUnits() {
      this.querySelectorAll('.msg-u').forEach((u) => { u.textContent = '(' + this.unit + ')'; });
      const b = this.querySelector('form[data-mode="body"]');
      if (b) this.fromBody(b);
    }

    fromBody(b) {
      let worst = -1, any = false;
      const shoes = this.cfg.cat === 'shoes';
      for (const ci of this.m) {
        let x = parseFloat(String(b['m' + ci].value).replace(',', '.'));
        if (!x) continue;
        any = true;
        if (this.unit === 'in') x = x * 2.54;
        let idx = -1;
        for (let i = 0; i < this.rows.length; i++) {
          const r = range(this.rows[i][ci]);
          if (!r) continue;
          // shoes: smallest size whose length is >= foot; clothing: smallest size whose upper bound fits
          if ((shoes ? r[1] : r[1]) >= x - 0.001) { idx = i; break; }
        }
        if (idx === -1) { this.result([], 'Your measurements are outside this chart.'); return; }
        worst = Math.max(worst, idx);
      }
      this.result(any ? [worst] : []);
    }

    result(rowIdx, msg) {
      const out = this.querySelector('.msg-result');
      if (msg) { out.innerHTML = '<p>' + esc(msg) + '</p>'; return; }
      if (!rowIdx.length) { out.innerHTML = ''; return; }
      const matches = [];
      rowIdx.forEach((i) => this.rowSizes[i].forEach((s) => { if (!matches.includes(s)) matches.push(s); }));
      const ref = this.rows[rowIdx[0]];
      const refTxt = this.scales().slice(0, 3).map((x) => esc(this.cols[x.ci]) + ' ' + esc(ref[x.ci])).filter((t) => !/\s$/.test(t)).join(' · ');
      if (!matches.length) {
        const last = Math.max(...rowIdx), first = Math.min(...rowIdx);
        let up = null, down = null;
        for (let i = last + 1; i < this.rows.length && !up; i++) up = this.rowSizes[i].find((s) => s.a) || null;
        for (let i = first - 1; i >= 0 && !down; i--) down = this.rowSizes[i].find((s) => s.a) || null;
        const alt = [up && { s: up, t: 'Closest larger size' }, down && { s: down, t: 'Closest smaller size' }].filter(Boolean);
        out.innerHTML = '<p class="msg-res-title">Your size: <strong>' + refTxt + '</strong></p><p>This item is not available in your exact size.</p>' +
          alt.map((x) => '<div class="msg-res"><span class="msg-res-size">' + esc(x.s.v) + '</span><span class="msg-res-av">' + x.t + '</span><button type="button" class="msg-pick" data-v="' + esc(x.s.v) + '">Select</button></div>').join('');
        out.querySelectorAll('.msg-pick').forEach((b) => b.addEventListener('click', () => this.pick(b.dataset.v)));
        return;
      }
      out.innerHTML = '<p class="msg-res-title">Recommended for this item</p>' + matches.map((s) =>
        '<div class="msg-res"><span class="msg-res-size">' + esc(s.v) + '</span>' +
        '<span class="msg-res-av">' + (s.a ? 'Available' : 'Sold out') + '</span>' +
        (s.a ? '<button type="button" class="msg-pick" data-v="' + esc(s.v) + '">Select</button>' : '') + '</div>').join('') +
        '<p class="msg-hint">' + refTxt + '</p>';
      out.querySelectorAll('.msg-pick').forEach((b) => b.addEventListener('click', () => this.pick(b.dataset.v)));
    }

    pick(v) {
      const inp = [...document.querySelectorAll('variant-picker input[type="radio"]')].find((i) => i.value === v);
      if (inp) { inp.click(); }
      else {
        const sel = [...document.querySelectorAll('variant-picker select')].find((s) => [...s.options].some((o) => o.value === v));
        if (sel) { sel.value = v; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      this.close();
    }

    open() {
      this.renderTable();
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal(); else this.dialog.setAttribute('open', '');
      document.documentElement.classList.add('msg-lock');
    }

    close() {
      if (this.dialog.open) this.dialog.close();
      document.documentElement.classList.remove('msg-lock');
    }
  }

  customElements.define('macondo-size-guide', MacondoSizeGuide);
  document.addEventListener('close', (e) => { if (e.target.classList && e.target.classList.contains('msg-dialog')) document.documentElement.classList.remove('msg-lock'); }, true);
})();
